export const setMetaElement = (name: string, content?: string | null): void => {
  const element: HTMLMetaElement | null = document.querySelector(
    `meta[name=${name}]`
  );
  if (element) {
    element.name = name;
    element.content = content ?? "";
  } else {
    const element = document.createElement("meta");
    element.name = name;
    element.content = content ?? "";
    document.head.appendChild(element);
  }
};
